import { css } from "@emotion/react";
import { Spacing } from "@snapchat/snap-design-system";
import { breakpointMap } from "shared-resources";

export const mainStyling = css`
    overflow: auto;
    height: 100%;
`;

export const controlSpacing = css`
    padding: 0 ${Spacing.MD}px ${Spacing.SM}px;
    @media (max-width: ${breakpointMap.sm}px) {
        padding: ${Spacing.SM}px 0;
    }
`;

export const submitContainer = css`
    position: relative;
    @media (max-width: 900px) {
        position: relative;
        width: 100%;
        margin-top: 2rem;
        margin-bottom: 1rem;
    }
`;

export const submitStyling = css`
    position: absolute;
    bottom: 4px;

    @media (min-width: 900px) {
        height: 80px;
    }
`;

export const sectionDropdown = css`
    @media (max-width: ${breakpointMap.sm}px) {
        display: flex;
        flex-direction: column;
        max-width: 70vw;
    }
`;
